import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { FocusFallbackContext } from './context';
import { FocusFallbackListener } from './listener';

export const FocusFallbackProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const value = useMemo(() => ({ fallbacks: [] }), []);

	return (
		<FocusFallbackContext.Provider value={value}>
			<FocusFallbackListener>{children}</FocusFallbackListener>
		</FocusFallbackContext.Provider>
	);
};
